class BogaAssetSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.slider = this.querySelector('.asset-slider__assets');
    this.slides = this.slider.querySelectorAll('.asset-slider__asset-wrap');
    this.currentIndex = 0;
    this.updateSelection();
    setInterval(() => {
      this.updateSelection();
    }, 4000);
  }

  updateSelection() {
    const newIndex = this.currentIndex + 1 < this.slides.length ? this.currentIndex + 1 : 0;
    this.slides.forEach((slide, index) => {
      const wasSelected = index === this.currentIndex;
      const isSelected = index === newIndex;
      slide.setAttribute('aria-active', isSelected ? 'true' : 'false');
      slide.setAttribute('tabindex', isSelected ? '0' : '-1');
      if (wasSelected) {
        slide.classList.add('sliding-out');
        setTimeout(() => {
          slide.classList.remove('sliding-out');
        }, 600);
      }
    });
    this.currentIndex = newIndex;
  }
}

window.customElements.define('boga-asset-slider', BogaAssetSlider);
